import { EditorState } from "draft-js";

import addAtomicBlock from "../../../../utils/addAtomicBlock";
import * as types from "../constants";

const addEmbed = (editorState: EditorState, data = {}) =>
  addAtomicBlock(editorState, types.OEMBED_CONTENT_TYPE, data);

export default addEmbed;
